import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import apiRequest from "../../../../utils/admin/apiRequest";
import InputField from "../../../ui/form/InputField";
import FileInputField from "../../../ui/form/FileInputField";
import Button from "../../../ui/utils/Button";
import usePost from "../../../../hooks/api/usePost";
import Alert from "../../../ui/utils/Alert";
import CheckboxField from "../../../ui/form/CheckboxField";

const EditMainCategory = ({ data, closeModal, callback }) => {
  const [preview, setPreview] = useState(null);

  const {
    error,
    isLoading: loading,
    post,
    serverErrors,
  } = usePost(apiRequest.updateMainCategory);


  const formik = useFormik({
    initialValues: {
      name: data?.name,
      start: data?.start,
      end: data?.end,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      const formData = new FormData();
      formData.append("name", values.name);
      formData.append("start", values.start);
      formData.append("end", values.end);


      const response = await post({ data: { body: values, id: data?._id } });
      if (response.response) {
        callback?.();
        resetForm();
        closeModal();
      }


    },
  });

  return (
    <div>
      <h2 className="p-4 text-lg font-semibold">Update Category</h2>
      <div className="border-b" />
      <form onSubmit={formik.handleSubmit} className="text-sm">
        {error && <Alert message={error} type="error" />}
        <div className="p-4 grid grid-cols-1 sm:grid-cols-2 gap-2">
          <InputField
            name="name"
            label="Category Name"
            value={formik.values.name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched?.name && formik.errors.name}
            serverError={serverErrors?.name}
            placeholder="Enter category name"
            disabled={true}
          />

          <InputField
            name="start"
            type="time"
            label="Start Time"
            value={formik.values.start}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched?.start && formik.errors.start}
            serverError={serverErrors?.start}
          />

          <div className="col-span-full">
            <InputField
              name="end"
              type="time"
              label="End Time"
              value={formik.values.end}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched?.end && formik.errors.end}
              serverError={serverErrors?.end}
            />
          </div>

          
        </div>

        <div className="border-b" />
        <div className="flex justify-end gap-2 p-4">
          <Button variant="secondary" onClick={closeModal}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="primary"
            loadingText="Updating..."
            isLoading={loading}
          >
            Update
          </Button>
        </div>
      </form>
    </div>
  );
};

export default EditMainCategory;
